import { render, staticRenderFns } from "./AppSelectForm.vue?vue&type=template&id=4ed20630&scoped=true"
import script from "./AppSelectForm.vue?vue&type=script&lang=js"
export * from "./AppSelectForm.vue?vue&type=script&lang=js"
import style0 from "./AppSelectForm.vue?vue&type=style&index=0&id=4ed20630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed20630",
  null
  
)

export default component.exports